export default __webpack_public_path__ + "static/media/features1.5131ce61.png";